import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

export default function TrackViewedInternationalSettingsConfirmation(props) {
  trackEvent({
    eventName: MParticleEventName.ViewedInternationalSettingsConfirmation,
    oldShippingRegionCode: props.old_shipping_region_code,
    oldCurrency: props.old_currency,
    newShippingRegionCode: props.new_shipping_region_code,
    newCurrency: props.new_currency,
  });
  return null;
}
